export const prefetchRoute = (path: string) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("mdcc:prefetch-route", { detail: path }));
};